export default __webpack_public_path__ + "static/media/lead-convert.cd366056.png";